import { useEffect, useRef, useState } from "react";
import { p, TENANT_KEY, STAFF_KEY } from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import { Avvio } from "@/components/Avvio";
import { DemoIngresso } from "@/components/demo/DemoIngresso";
import { avviaTour, spegniTour } from "@/components/demo/PercorsoDemo";

const RUOLI = {
  titolare: "titolare",
  sala: "sara",
  cucina: "marco",
  direttore: "luca",
  pizzeria: "youssef",
  bar: "elena",
};

// Accesso diretto alla demo: /demo (titolare) oppure /demo/sala, /demo/cucina…
export default function DemoEntra() {
  const [errore, setErrore] = useState("");
  const [pronto, setPronto] = useState(false);
  const [entra, setEntra] = useState(false);
  const sessione = useRef(null);

  useEffect(() => {
    const parti = window.location.pathname.split("/").filter(Boolean);
    // /vetrina è la scorciatoia pulita da mettere sui siti: sola visione, si entra in sala.
    const vetrina = parti[0] === "vetrina";
    const chiave = (vetrina ? parti[1] || "sala" : parti[1] || "titolare").toLowerCase();
    const username = RUOLI[chiave] || chiave;
    const params = new URLSearchParams(window.location.search);
    const slug = params.get("locale") || "osteria-del-vicolo";
    // Link vetrina: si naviga tutto, non si modifica nulla.
    const soloLettura = vetrina || ["solo-lettura", "vetrina", "1"].includes((params.get("vista") || "").toLowerCase());
    (async () => {
      try {
        localStorage.removeItem(TENANT_KEY);
        localStorage.removeItem("rh_user");
        // La sessione si prepara mentre il visitatore legge: quando tocca «Iniziamo» è già pronta
        sessione.current = await p("/tenant/demo-login", { slug, username, view_only: soloLettura,
                                                           key: params.get("k") || "" });
        setPronto(true);
      } catch (e) {
        setErrore(e?.response?.data?.detail === "demo_chiusa" ? "chiusa"
                  : e?.response?.data?.detail || "Demo non raggiungibile");
      }
    })();
  }, []);

  const apri = (guidata) => {
    const r = sessione.current;
    if (!r) return;
    if (guidata) avviaTour();
    else spegniTour();
    localStorage.setItem(TENANT_KEY, r.token);
    localStorage.removeItem(STAFF_KEY);
    localStorage.setItem("rh_user", JSON.stringify(r.user));
    setEntra(true);
    window.location.replace("/");
  };

  if (entra) return <Avvio nome="Osteria del Vicolo" nota="Apro la demo…" />;

  if (!errore)
    return (
      <DemoIngresso pronto={pronto} onGuidata={() => apri(true)} onLibera={() => apri(false)} />
    );

  if (errore === "chiusa")
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 p-6 text-center" data-testid="demo-chiusa">
        <div className="max-w-sm">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-500 font-head text-2xl font-bold text-slate-950">
            RH
          </span>
          <h1 className="mt-5 font-head text-2xl font-bold text-white">La demo è chiusa in questo momento</h1>
          <p className="mt-2 text-sm text-slate-400">
            Questa vetrina è temporaneamente sospesa. Se vuoi vedere Reprehendo al lavoro, apri la
            tua prova gratuita: si configura sulla tua attività in un minuto.
          </p>
          <a href="/prova" className="mt-6 inline-block rounded-lg bg-amber-500 px-5 py-3 text-sm font-bold text-slate-950"
             data-testid="demo-chiusa-cta">
            Provalo gratis
          </a>
        </div>
      </div>
    );

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6" data-testid="demo-entra">
      <div className="max-w-sm text-center" data-testid="demo-entra-error">
        <AlertTriangle className="mx-auto h-6 w-6 text-amber-500" />
        <p className="mt-3 text-sm font-semibold">{errore}</p>
        <a href="/entra" className="mt-4 inline-block text-sm font-semibold text-amber-700 hover:underline">
          Entra con nome attività e codice
        </a>
      </div>
    </div>
  );
}
